<template>
  <div class="container">
    <div class="tab_container">
      <el-tabs v-model="appointmentTabs">
        <!-- 到考试预约时间那里结束 -->
        <el-tab-pane label="预约信息" name="appointmentInfo">
          <div class="title"><h2>预约科目</h2></div>
          <div class="section">
            <h4>预约考试等级 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.examRank}}
            </div>
            <div class="from_check" style="margin-top:12px">
              <div class="mask"></div>
              <van-checkbox-group v-model="studentDetails.subjectArray" disable>
                <van-checkbox v-for="(item,index) in subjectArray" :key="index" style="margin:10px 0" :name="item.name" checked-color="#1989fa" shape="square">
                  {{item.name}}（{{item.price}}元）
                </van-checkbox>
              </van-checkbox-group>
            </div>  
          </div>
          <template v-if="studentDetails.subject =='理论'&& theoryAppointment && JSON.stringify(theoryAppointment) != '{}'||studentDetails.subject =='理论，实操'&& theoryAppointment && JSON.stringify(theoryAppointment) != '{}' ">
            <div class="title"><h2>预约理论考试</h2></div>
            <div class="section">
              <h4>预约考试地点</h4>
              <div class="from_input">
                {{theoryAppointment.address}}
              </div>
              <h4 style="margin-top: 10px">预约考试时间</h4>
              <div class="from_input">
                {{theoryAppointment.time}}
              </div>
            </div>
          </template>
          
          <template v-if="studentDetails.subject=='实操'&& operationAppointment && JSON.stringify(operationAppointment) != '{}' || studentDetails.subject =='理论，实操'&& theoryAppointment && JSON.stringify(theoryAppointment) != '{}'">
            <div class="title"><h2>预约实操考试</h2></div>
            <div class="section">
              <h4>预约考试地点</h4>
              <div class="from_input">
                {{operationAppointment.address}}
              </div>
              <h4 style="margin-top: 10px">预约考试时间</h4>
              <div class="from_input">
                {{operationAppointment.time}}
              </div>
            </div>
          </template>
          <div class="button_box">
            <el-button type="primary" v-if="(studentInfo.status == 'auditing'||studentInfo.status == 'beingReviewed') && studentInfo.detailStatus !='confirmed'" @click="onPass" size="mini">通过</el-button>
            <el-button type="primary" v-if="(studentInfo.examPay==='institutionPay' && studentInfo.status ==='payAuditing' && studentInfo.payType !== null) && studentInfo.detailStatus !='confirmed'" @click="onConfirm" size="mini">确认已收款</el-button>
            <el-button type="primary" v-if="(studentInfo.examPay ==='institutionPay' && studentInfo.status ==='auditing' && studentInfo.payType === null || studentInfo.examPay ==='institutionPay' && studentInfo.status ==='beingReviewed' || studentInfo.examPay ==='institutionPay' && studentInfo.status ==='payAuditing' && studentInfo.payType !== null || studentInfo.examPay ==='examineePay' && studentInfo.payType == 'onlinePay' && studentInfo.status != 'toTest')&& studentInfo.detailStatus !='confirmed'" @click="onReject" plain size="mini">驳回</el-button>
          </div>
        </el-tab-pane>
        <!-- 到手机号码那里结束-->
        <el-tab-pane label="基本信息" name="baseInfo">
          <div class="title"><h2>预约信息</h2></div>
          <div class="section">
            <h4>姓名 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.examName}}
            </div>
            <h4>证件类型 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.examCardStatus}}
            </div>
            <h4>证件号码 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.examCard}}
            </div>
            <h4>出生日期</h4>
            <div class="from_input">
              {{studentDetails.birthdate ? studentDetails.birthdate : ''}}
            </div>
            <h4>手机号码 <span class="red">*</span></h4>
            <div class="from_input" style="margin-bottom:5px">
              {{studentDetails.examPhone}}
            </div>
            <div class="sex">
               <h4 style="margin-right: 30px">性别 <span class="red">*</span></h4>
              <div class="from_check">
                <van-radio-group v-model="studentDetails.examSex" direction="horizontal">
                  <van-radio name="男">男</van-radio>
                  <van-radio name="女">女</van-radio>
                </van-radio-group>
              </div>
            </div>
            <h4>民族</h4>
            <div class="from_input">
              {{studentDetails.nation}}
            </div>
            <h4>政治面貌</h4>
            <div class="from_input">
              {{studentDetails.politicsstatus}}
            </div>
            <h4>所属群体 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.referenceGroup}}
            </div>
            <h4>工作单位 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.workunit}}
            </div>
            <h4>职业年限（年） <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.term}}
            </div>
            <h4>现居地址 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.currentaddress + filterData(studentDetails.downtown)}}
            </div>
            <h4>职业 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.profession}}
            </div>
            <h4>鉴定分类 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.classification}}
            </div>
            <h4>邮政编码</h4>
            <div class="from_input">
              {{studentDetails.postalcode}}
            </div>
            <h4>从事职业</h4>
            <div class="from_input">
              {{studentDetails.engineer}}
            </div>
            <h4>参加工作日期</h4>
            <div class="from_input">
              {{studentDetails.dateofentry}}
            </div>
            <h4>身份信息</h4>
            <div class="from_input">
              {{studentDetails.identity}}
            </div>
          </div>
          <div class="button_box">
            <el-button type="primary" v-if="(studentInfo.status == 'auditing'||studentInfo.status == 'beingReviewed') && studentInfo.detailStatus !='confirmed'" @click="onPass" size="mini">通过</el-button>
            <el-button type="primary" v-if="(studentInfo.examPay==='institutionPay' && studentInfo.status ==='payAuditing' && studentInfo.payType !== null)&& studentInfo.detailStatus !='confirmed'" @click="onConfirm" size="mini">确认已收款</el-button>
            <el-button type="primary" v-if="(studentInfo.examPay ==='institutionPay' && studentInfo.status ==='auditing' && studentInfo.payType === null || studentInfo.examPay ==='institutionPay' && studentInfo.status ==='beingReviewed' || studentInfo.examPay ==='institutionPay' && studentInfo.status ==='payAuditing' && studentInfo.payType !== null || studentInfo.examPay ==='examineePay' && studentInfo.payType == 'onlinePay' && studentInfo.status != 'toTest')&& studentInfo.detailStatus !='confirmed'" @click="onReject" plain size="mini">驳回</el-button>
          </div>
        </el-tab-pane>
        <!-- 从预约条件那里开始到最后 -->
        <el-tab-pane label="文件信息" name="fileInfo">
          <div class="title"><h2>预约条件</h2></div>
          <div class="section">
            <h4>申报条件 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.acceptance}}
            </div>
            <h4>文化程度 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.examRecord}}
            </div>
            <h4>毕业时间 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.examGetTime}}
            </div>
            <h4>毕业学校 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.schoolTag}}
            </div>
            <h4>毕业证书 <span class="red">*</span></h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="毕业证书" fileName="毕业证书.PDF" :mainup="studentDetails.diploma"></file-box>
              </div>
            </div>
            <h4>社保记录 </h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="社保记录" fileName="社保记录.PDF" :mainup="studentDetails.socialSecurity"></file-box>
              </div>
            </div>
            <h4>上传工作经验及证明文件 <span class="red">*</span></h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="工作证明" fileName="工作证明.PDF" :mainup="studentDetails.certificate"></file-box>
              </div>
            </div>
            <h4>身份证（正反面） <span class="red">*</span></h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="身份证扫描件" fileName="身份证扫描件.PDF" :mainup="studentDetails.cardpositive"></file-box>
              </div>
            </div>
            <h4>本人证件照 <span class="red">*</span></h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="本人证件照" fileName="证件照.JPG" :mainup="studentDetails.examIdentificationImg"></file-box>
              </div>
            </div>
            <h4>报名申报表 <span class="red">*</span></h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="报名申报表" fileName="报名申报表.PDF" :mainup="studentDetails.registrationForm"></file-box>
              </div>
            </div>
            <h4>学信网验证报告 <span class="red">*</span></h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="学信网验证报告" fileName="学信网验证报告.PDF" :mainup="studentDetails.xuexinelectronic"></file-box>
              </div>
            </div>
            <h4>职业技能/职业资格/职称证书</h4>
            <div class="form_file">
              <div class="file-wrap">
                <file-box headert="证书" fileName="职业技能/职业资格/职称证书.PDF" :mainup="studentDetails.completionCertificate"></file-box>
              </div>
            </div>
            <h4>邮寄证书地址 <span class="red">*</span></h4>
            <div class="from_input">
              {{studentDetails.examCertificate}}
            </div>
            <h4>报名备注</h4>
            <div class="from_input" style="margin-bottom:5px">
              {{studentDetails.remark}}
            </div>
            <div class="bottom"></div>
          </div>
          <div class="button_box">
            <el-button type="primary" v-if="(studentInfo.status == 'auditing'||studentInfo.status == 'beingReviewed') && studentInfo.detailStatus !='confirmed'" @click="onPass" size="mini">通过</el-button>
            <el-button type="primary" v-if="(studentInfo.examPay==='institutionPay' && studentInfo.status ==='payAuditing' && studentInfo.payType !== null)&& studentInfo.detailStatus !='confirmed'" @click="onConfirm" size="mini">确认已收款</el-button>
            <el-button type="primary" v-if="(studentInfo.examPay ==='institutionPay' && studentInfo.status ==='auditing' && studentInfo.payType === null || studentInfo.examPay ==='institutionPay' && studentInfo.status ==='beingReviewed' || studentInfo.examPay ==='institutionPay' && studentInfo.status ==='payAuditing' && studentInfo.payType !== null || studentInfo.examPay ==='examineePay' && studentInfo.payType == 'onlinePay' && studentInfo.status != 'toTest')&& studentInfo.detailStatus !='confirmed'" @click="onReject" plain size="mini">驳回</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="passDialogVisible" :before-close="close" :close-on-click-modal="false" width="30%" center>
        <span style="text-align: center">确定要通过该考生的报考信息吗?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onPassCancel">取 消</el-button>
          <el-button type="primary" @click="onPassConfirm" ref="passConfirm">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="confirmDialogVisible" :before-close="close" :close-on-click-modal="false" width="30%" center>
        <span style="text-align: center">确定已收到款项？点击确定后,与当前考生相同订单编号的其他考生都将确认已收款</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onReceiptCancel">取 消</el-button>
          <el-button type="primary" @click="onReceiptConfirm">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="驳回原因" :visible.sync="rejectDialogVisible" :before-close="close" :close-on-click-modal="false" width="30%" center>
        <textarea v-model="rejectReason" name="" id="" cols="30" studentInfos="10" placeholder="输入文字" style="background-color: #f6f6f6;border: none; width: 100%"></textarea>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onRejectCancel">取 消</el-button>
          <el-button type="primary" @click="onRejectConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import fileBox from "@/components/filebox.vue";
export default {
  components: {
    fileBox
  },
  data() {
    return{
      passDialogVisible: false,  // 控制 点击 "通过" 按钮时 ，对话框 的 显示 与隐藏,
      rejectDialogVisible: false,  // 控制 点击 "驳回" 按钮时 ，对话框的 显示 与隐藏
      confirmDialogVisible: false, // 控制 点击 "确认已收款" 按钮时 ，对话框 的 显示 与隐藏
      appointmentTabs: 'appointmentInfo',
      studentDetails: {},
      subjectArray: [],
      theoryAppointment: {},  //预约时间地点
      operationAppointment: {},
      rejectReason: '', // 驳回原因
      detailId: '', // 详情页的 id
      studentInfo: {} // 整个详情页对象
    }
  },
  props:{
    detailInfoId: {
      type: String
    },
    detailInfo: {
      type: Object
    }
  },
  created() {
    this.fetchDetails()
  },
  watch: {
    'studentDetails.examRank': function() {
      this.getSubject()
    },
    detailInfoId(newVal,oldVal){
      this.detailId = newVal
    },
    detailInfo(newVal,oldVal){
      this.studentInfo = newVal
    },
    // 立即触发
    immediate: true
  },

  methods: {
    fetchDetails: function () {
      const params = {
        id: JSON.stringify(this.$route.params) != "{}" ? this.$route.params.id : this.detailId,
      }
      this.$http.get("registration/one", {params}).then((res) => {
        if (res.data.success) {
          let data = res.data.data
          this.studentDetails = data.info
          this.theoryAppointment = data.theory
          this.operationAppointment = data.operation
          if(this.theoryAppointment && this.theoryAppointment.day){
            this.theoryAppointment.time = this.theoryAppointment.day + ' ' + this.theoryAppointment.period
            this.theoryAppointment.address = this.theoryAppointment.addressDetail
          }
          if(this.operationAppointment && this.operationAppointment.day){
            this.operationAppointment.time = this.operationAppointment.day + ' ' + this.operationAppointment.period
            this.operationAppointment.address = this.operationAppointment.addressDetail
          }
          if(data.info.subject){
            this.$set(this.studentDetails, "subjectArray", this.studentDetails.subject.split('，'))
          }
        } else {
          console.log(err);
        }
      })
      .catch((err) => console.log(err));
    },
    filterData: function(data) {
      return data || ''
    },
    getSubject: function() {
      let params = {
        examRank: this.studentDetails.examRank,
        id: JSON.stringify(this.$route.params) != "{}" ? this.$route.params.id : this.detailId,
      }
      this.$http.get('/registration/subject/list', {params}).then(res => {
        if(res.data.success) {
          this.subjectArray = res.data.data
        }
      })
    },
    // 点击 "通过" 按钮
    onPass(){
      this.passDialogVisible = true;
    },
    // 隐藏详情页
    hideDetails(){
      let listBox  = this.$parent.$el.querySelector('.tab_container')
      listBox.style.width = '100%'
      let infoBox = this.$parent.$el.querySelector('.info_container')
      infoBox.style.width = '0'
    },
    // 点击 "通过" 按钮 后，点击 弹框的 "确定"按钮
    onPassConfirm() {
      this.$http.put(`association/pass?ids=` + this.detailId).then((res) => {
        if(res.data.success && res.status == 200){
          this.$message({
            message: "通过成功",
            type: "success",
          })
          if(this.studentInfo.examPay === 'examineePay'){
            this.studentInfo.status = 'toTest'
          }else if (this.studentInfo.examPay === 'institutionPay'){
            this.studentInfo.status = 'payAuditing'
          }
          this.hideDetails()
          this.$parent.getPageList() // 改变状态以后调用一下这个方法，刷新页面
        }
      });
      this.passDialogVisible = false
    },
    // 点击 "通过" 按钮后，点击 弹框的 "取消"按钮
    onPassCancel() {
      this.passDialogVisible = false
    }, 
    // 点击 "驳回" 按钮
    onReject(){
      this.rejectDialogVisible = true;
    },

    // 点击 "驳回"按钮后，点击 弹框的 "确定"按钮
    onRejectConfirm(){
      if(!this.rejectReason){
        this.$message({
          message: "请输入驳回原因",
          type: "error",
        })
        this.rejectDialogVisible = true;
      }else{
        this.$http.put(`association/reject?ids=` + this.detailId + `&reason=` + this.rejectReason).then((res) => {
          if (res.data.success && res.status == 200) { 
            this.$message({
              message: "驳回成功",
              type: "success",
            })
            if(this.studentInfo.payStatus !== null) {
              this.studentInfo.payStatus = 'rejected' // 支付驳回
              this.studentInfo.status = 'payRejected' // 报名审核状态是 "通过"
            }else{
              this.studentInfo.status = 'rejected'                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
            }
            this.hideDetails()
            this.$parent.getPageList() // 取消状态以后再次调用这个方法，刷新页面
            this.rejectReason = '' // 驳回数据以后 清空 驳回原因, 避免数据回显, 把上一条数据的驳回原因带给下一条数据
          }
        });
        this.rejectDialogVisible = false;
      }
    },

    // 点击 "驳回"按钮后点击 弹框的 "取消"按钮
    onRejectCancel(){
      // 点击取消时, 清空数据, 避免数据回显造成数据关闭弹框以后数据带到下一条里面
      this.rejectReason = ''
      this.rejectDialogVisible = false;
    },

    // 点击 "确认已收款" 按钮
    onConfirm(){
      this.confirmDialogVisible = true
    },
    
    // 点击"确认已收款"按钮后，点击 弹框的 "确定"按钮
    onReceiptConfirm() {
      this.$http.put(`association/confirmReceipt?ids=` + this.detailId).then((res) => {
        if (res.data.success && res.status == 200) {
          this.$message({
            message: "确认收款成功",
            type: "success",
          })
          this.studentInfo.payStatus = 'paid'
          this.studentInfo.status = 'toTest'
          this.hideDetails()
          this.$parent.getPageList() // 取消状态以后再次调用这个方法，刷新页面
        }
      })
      this.confirmDialogVisible = false
    },
 
    // 点击 "确认已收款"按钮后，点击 弹框的 "取消"按钮
    onReceiptCancel() {
      this.confirmDialogVisible = false
    },
    // 关闭弹框
    close(done){
      this.auditStatus = this.auditStatus // 点击 "关闭" 对话, 控制状态不变
      this.rejectReason = '' // 点击 'x' 时, 清空数据, 避免数据回显造成数据关闭弹框以后数据带到下一条里面
      done()
    },
  }

}
</script>


<style lang="less" scoped>
*{
  box-sizing: border-box;
  font-size: 13PX;
}
h2{
  font-size: 14PX;
}
h4{
  font-size: 13PX;
}
.section{
  box-sizing: border-box;
  margin-top: 10PX;
  background: white;
}

.container{
  width: 100%;
   height: 100%;
  background: white;  
  .tab_container{
    width: 100%;
    // margin-top: -20px;
    height: 100%;
    .button_box{
      display: flex;
      justify-content: space-around;
      ::v-deep .el-button {
        width: 120PX;
      }
    }
  }
}

.title{
  width: 100%;
  height: 36PX;
  background: #EEEEEE;
  padding: 8PX;
}

.from_input{
  margin-top: 5px;
  width: 100%;
  min-height: 40px;
  padding-left: 12px;
  border: 1px solid #DCDCDC;
  cursor: default;
  margin-bottom: 12px;
  
}
.from_check{
  position: relative;
  margin-bottom: 10px;
}
.form_file{
  position: relative;
  margin: 15px 0 20px 0;
  .fileboxmain[data-v-44b7516f] {
    background: #F5F5F5;
    width: 4.4rem;
    height: 1.2rem;
    border: 0.02667rem solid #54B0FB;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.flex{
  display: flex;
}
.sex{
  display: flex;
}
.red{
  color: red;
}
.bottom{
  width: 100%;
  height: 60px;
}
</style>